/** Full signed-in loop — shown on Study hub & Notebook hub playbooks. */
export const APP_JOURNEY = {
  title: 'How QnaRead works end to end',
  lead:
    'One loop: discover Q&A, save what you need, then Review and Practice until it sticks. Study hub ties it together each day.',
  steps: [
    {
      id: 'library',
      label: 'Library',
      path: '/library',
      text: 'Search and read shared Q&A across topics.',
    },
    {
      id: 'learn',
      label: 'Learn',
      path: '/hub',
      text: 'Create notebooks; import PDF, URL, or paste.',
    },
    {
      id: 'save',
      label: 'Save',
      path: '/saved',
      text: 'Bookmark cards while reading — builds your deck.',
    },
    {
      id: 'study',
      label: 'Study hub',
      path: '/dashboard',
      text: 'Due count, daily goal, and what to do next.',
    },
    {
      id: 'review',
      label: 'Review',
      path: '/review',
      text: 'Clear the spaced-repetition queue when due.',
    },
    {
      id: 'practice',
      label: 'Practice',
      path: '/practice',
      text: 'Active recall with saved cards anytime.',
    },
  ],
};
